import React, { memo } from 'react';
import { Text } from '@Sage/hoi-poi-ui';
import MetadataPopover from 'components/MetadataPopover';

const TitleRow = memo(
    ({ value, leftContent, rightContent, metadata, entity, readOnlyIndicator }) => {
        return (
            <div className="title-row__container">
                <div className="title-row__info">
                    {(value || leftContent) && (
                        <div className="title-row--left">
                            {readOnlyIndicator}
                            {leftContent}
                            {!leftContent && value && <Text type="h6">{value}</Text>}
                            {metadata && <MetadataPopover data={metadata} entity={entity} />}
                        </div>
                    )}
                    {rightContent && <div className="title-row--right">{rightContent}</div>}
                </div>
            </div>
        );
    },
);

export default TitleRow;
